export enum AgGridFilterType {
  Text = 'text',
  Number = 'number',
  Date = 'date',
  Dropdown = 'dropdown',
}

export enum AgGridFilterTypeDto {
  Text = 'TEXT',
  Number = 'NUMBER',
  Date = 'DATE',
  Multiselect = 'MULTISELECT',
}
